export const TOKEN_SESSION_KEY = 'TOKEN';
export const BUISNESS_CATEGORY_KEY = 'buisness_categories';
export const MERCHANT_TYPE_KEY = 'merchant_type';
